import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';
import LinkIcon from '@mui/icons-material/Link';
import PhoneIcon from '@mui/icons-material/Phone';
import SendIcon from '@mui/icons-material/Send';
import type { SvgIconComponent } from '@mui/icons-material';
import { Contact, ContactType } from '../models/Contact';

export function visibleOrganizationContacts(contacts: Contact[] | null | undefined): Contact[] {
  return (contacts ?? []).filter((contact) => contact.visible && Boolean(contact.value?.trim()));
}

function toExternalUrl(value: string): string {
  return value.startsWith('http') ? value : `https://${value.replace(/^\/+/, '')}`;
}

export function organizationContactHref(contact: Contact): string {
  const value = contact.value.trim();
  switch (contact.type) {
    case ContactType.PHONE_NUMBER:
      return `tel:${value}`;
    case ContactType.EMAIL:
      return `mailto:${value}`;
    case ContactType.INSTAGRAM: {
      if (value.startsWith('http')) return value;
      const username = value.startsWith('@') ? value.slice(1) : value;
      return `https://instagram.com/${username}`;
    }
    case ContactType.FACEBOOK:
      return value.startsWith('http') ? value : `https://facebook.com/${value}`;
    case ContactType.TELEGRAM: {
      if (value.startsWith('http')) return value;
      const username = value.startsWith('@') ? value.slice(1) : value;
      return `https://t.me/${username}`;
    }
    case ContactType.LINKTREE:
    case ContactType.WEBSITE:
    default:
      return toExternalUrl(value);
  }
}

export function organizationContactOpensInSameTab(contact: Contact): boolean {
  return contact.type === ContactType.PHONE_NUMBER || contact.type === ContactType.EMAIL;
}

export function organizationContactIcon(contact: Contact): SvgIconComponent {
  switch (contact.type) {
    case ContactType.PHONE_NUMBER:
      return PhoneIcon;
    case ContactType.EMAIL:
      return EmailIcon;
    case ContactType.INSTAGRAM:
      return InstagramIcon;
    case ContactType.FACEBOOK:
      return FacebookIcon;
    case ContactType.TELEGRAM:
      return SendIcon;
    case ContactType.LINKTREE:
      return LinkIcon;
    case ContactType.WEBSITE:
      return LanguageIcon;
    default:
      return LinkIcon;
  }
}
